module.exports = __webpack_public_path__ + "static/favicon-7a4c5e69176e733227d6d4bee5ecb14e.ico";